module.exports = __webpack_public_path__ + "img/416BA7_A5B8D0_0D2549_65ABEB-256px.97057a65.png";